import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PrivatePage } from 'src/components/auth';
import { MedicalHistoryScreen } from 'src/screens/medicalHistory';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IMedicalHistoryProps {}

const MedicalHistoryPage: React.FunctionComponent<
  IMedicalHistoryProps
> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('screens.medicalHistory')}</title>
      </Helmet>
      <PrivatePage>
        <MedicalHistoryScreen />
      </PrivatePage>
    </>
  );
};

export default MedicalHistoryPage;
